// extracted by mini-css-extract-plugin
export default {"root":"listItem_styles_root__G3V3g","details":"listItem_styles_details__kFInr"};